module.exports = __webpack_public_path__ + "static/media/thav.5598bb46.jpg";